export default __webpack_public_path__ + "static/media/instagram.dd2dee63.png";